import { FormInputText } from 'feature/formComponents'
import styles from '../CompanyRegistration.module.scss'

export function BankDetailsSection() {
  return (
    <div className={styles.companyRegistration__section}>
      <h3 className={styles.companyRegistration__sectionTitle}>
        Банковские реквизиты
      </h3>
      <FormInputText
        name='bankDetails.bankName'
        allowAllChars
        inputProps={{
          label: 'Название банка',
          required: true,
          inputProps: { maxLength: 128 },
          'data-testid': 'company-reg-bank-name',
        }}
      />
      <FormInputText
        name='bankDetails.bik'
        numericOnly
        rules={{
          required: 'БИК обязателен для заполнения',
          validate: (v: string) =>
            !v || /^\d{9}$/.test(v) || 'БИК должен содержать 9 цифр',
        }}
        inputProps={{
          label: 'БИК',
          required: true,
          placeholder: '9 цифр',
          inputProps: { maxLength: 9 },
          'data-testid': 'company-reg-bik',
        }}
      />
      <FormInputText
        name='bankDetails.correspondentAccount'
        numericOnly
        rules={{
          required: 'Корреспондентский счет обязателен для заполнения',
          validate: (v: string) =>
            !v ||
            /^\d{20}$/.test(v) ||
            'Корреспондентский счет должен содержать 20 цифр',
        }}
        inputProps={{
          label: 'Корреспондентский счет',
          required: true,
          placeholder: '20 цифр',
          inputProps: { maxLength: 20 },
          'data-testid': 'company-reg-correspondent-account',
        }}
      />
      <FormInputText
        name='bankDetails.currentAccount'
        numericOnly
        rules={{
          required: 'Расчетный счет обязателен для заполнения',
          validate: (v: string) =>
            !v ||
            /^\d{20}$/.test(v) ||
            'Расчетный счет должен содержать 20 цифр',
        }}
        inputProps={{
          label: 'Расчетный счет',
          required: true,
          placeholder: '20 цифр',
          inputProps: { maxLength: 20 },
          'data-testid': 'company-reg-current-account',
        }}
      />
    </div>
  )
}
